import { useContext, useEffect, useRef, useState } from 'react';
import GeneralContext from '../../context/GeneralContext';
import NavMenu from '../NavMenu';
import { useNavigate } from 'react-router-dom';

function ModalMenu() {

    const { userType, modalType, changeUserMenu, changeCurrentMenu, logout } = useContext(GeneralContext);

    const test = () => {console.log('hola');}
    const menuFunction = useRef(test);
    
    const navigate = useNavigate();

    const logoutMenu = () => {
        logout();
        navigate('/');
    }

    const testFunction = () => console.log('click test');
    const [data, setData] = useState([
        {id: 0, navText: '', icon: 'FaUser', iconFamily: 'Fa', function: testFunction}
    ]);
    const [menuClass, setMenuClass] = useState('');
    
    const updateData = () => {
        if (userType === 'admin') {
            setMenuClass('menuDivAdmin');
            setData(
                [
                    {
                        id: 0,
                        navText: 'Mi Usuario',
                        icon: 'FaUser',
                        iconFamily: 'Fa',
                        function: menuFunction.current,
                        route: 'user'
                    },
                    {
                        id: 1,
                        navText: 'Gestionar Usuarios',
                        icon: 'FaUsers',
                        iconFamily: 'Fa',
                        function: menuFunction.current,
                        route: 'manage-users'
                    },
                    {
                        id: 2,
                        navText: 'Solicitudes',
                        icon: 'GiFiles',
                        iconFamily: 'Gi',
                        function: menuFunction.current,
                        route: 'manage-requests'
                    },
                    {
                        id: 3,
                        navText: 'Beneficios',
                        icon: 'GiPalmTree',
                        iconFamily: 'Gi',
                        function: menuFunction.current,
                        route: 'manage-benefits'
                    },
                    {
                        id: 4,
                        navText: 'Cambio de Puntos',
                        icon: 'GiCutDiamond',
                        iconFamily: 'Gi',
                        function: menuFunction.current,
                        route: 'manage-points'
                    },
                    {
                        id: 5,
                        navText: 'Cerrar Sesión',
                        icon: 'SlLogout',
                        iconFamily: 'Sl',
                        function: logoutMenu
                    }
                ]
            );
        } else if (userType === 'user') {
            setMenuClass('menuDiv');
            setData(
                [
                    {
                        id: 0,
                        navText: 'Usuario',
                        icon: 'FaUser',
                        iconFamily: 'Fa',
                        function: menuFunction.current,
                        route: 'user'
                    },
                    {
                        id: 1,
                        navText: 'Solicitar',
                        icon: 'FaFileUpload',
                        iconFamily: 'Fa',
                        function: menuFunction.current,
                        route: 'request'
                    },
                    {
                        id: 2,
                        navText: 'Puntos',
                        icon: 'GiTwoCoins',
                        iconFamily: 'Gi',
                        function: menuFunction.current,
                        route: 'points'
                    },
                    {
                        id: 3,
                        navText: 'Mis Solicitudes',
                        icon: 'FaBook',
                        iconFamily: 'Fa',
                        function: menuFunction.current,
                        route: 'history'
                    },
                    {
                        id: 4,
                        navText: 'Cerrar Sesión',
                        icon: 'SlLogout',
                        iconFamily: 'Sl',
                        function: logoutMenu
                    }
                ]
            );
        }
    }

    useEffect(() => {
        if (userType === 'user') {menuFunction.current = changeUserMenu};
        if (userType === 'admin') {menuFunction.current = changeCurrentMenu};
        updateData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [userType, menuFunction]);

    function closeModal (modal) {
        modal.style.animation = 'disappear 0.5s';
        modal.addEventListener("animationend", function finAnimacion () {
            modal.removeEventListener("animationend", finAnimacion);
            modal.style.display = "none";
            modal.style.animation = 'appear 0.5s';
            if (modalType === 'request') {
            document.getElementById('commentText').value = '';
            }
            if (modalType === 'adjust') {
            document.getElementById('adjustAmount').value = 0;
            document.getElementById('adjustText').value = '';
            }
        })
    }

    function closeMobileModal (modal) {
        modal.style.animation = 'disappear 0.5s';
        modal.addEventListener("animationend", function finAnimacion () {
            modal.removeEventListener("animationend", finAnimacion);
            modal.style.display = "none";
            modal.style.animation = 'appear 0.5s';
        })
    }

    window.onclick = function(event) {
        const mobileModal = document.getElementById("mobileModal");
        const modal = document.getElementById("myModal");
        if (event.target === mobileModal) {
            closeMobileModal(mobileModal);
        } else if (event.target === modal) {
            closeModal(modal);
        }
    }

  return (
    <div id='mobileModal' className='modal'>
        <div className='modal-menu-content'>
            <div className={menuClass} style={{height: '103vh'}}>
                <NavMenu data={data} />
            </div>
        </div>
    </div>
  )
}

export default ModalMenu